import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Assets
import { ArrowLeftIcon, ArrowRightIcon } from 'assets/images/Icons'

// Constants
import { PAGINATION_OPTIONS } from 'common/constants/formOptions'

// Styled Elements
import {
  PaginationWrapper,
  NavigationWrapper,
  NavigationPagesWrapper,
  RangeSelectorWrapper,
  RangeSelectorContainer,
  SummaryContainer,
} from './Pagination.elements'

// Views
import Button from '../Buttons/Button'
import SimpleSelect from '../Inputs/SimpleSelect'

function Pagination(props) {
  // Destructure
  const { onChange, itemsCountPerPage, totalItemsCount, pageRangeDisplayed, page } = props

  // States
  const [size, setSize] = useState(10)
  const [pageRange, setPageRange] = useState()
  const [totalPages, setTotalPages] = useState(Math.floor(totalItemsCount / itemsCountPerPage))
  const [pages, setPages] = useState([])

  // Functions
  const handlePageChange = (page) => {
    onChange({ page: +page, size })
  }

  const handlePages = () => {
    let tempPages = []
    tempPages.push(page)
    let before = page - 1
    let after = page + 1

    let { length } = tempPages
    while (length < pageRange) {
      if (before > 0) {
        tempPages = [before, ...tempPages]
        before -= 1
        length += 1
      }
      if (after <= totalPages) {
        tempPages = [...tempPages, after]
        after += 1
        length += 1
      }
    }

    // Only update if changed
    const newPages = JSON.stringify(tempPages)
    const oldPages = JSON.stringify(pages)
    if (newPages !== oldPages) {
      setPages(tempPages)
    }
  }

  const handleOnSelectChange = (value) => {
    setSize(+value)
    onChange({ page: 1, size: +value })
  }

  const handlePageRange = () => {
    const currTotalPages = Math.ceil(totalItemsCount / itemsCountPerPage)
    if (currTotalPages !== totalPages) {
      setTotalPages(currTotalPages)
    }
    const newPageRange = Math.min(pageRangeDisplayed, currTotalPages)
    if (newPageRange !== pageRange) {
      setPageRange(newPageRange)
    }
  }
  // UseEffects
  useEffect(() => {
    handlePageRange()
  }, [pageRangeDisplayed, totalItemsCount, itemsCountPerPage])
  useEffect(() => {
    handlePages()
  }, [pageRange, page])

  return (
    <PaginationWrapper>
      <RangeSelectorWrapper>
        {totalItemsCount > 0 && pages?.length > 0 && (
          <RangeSelectorContainer>
            <SimpleSelect options={PAGINATION_OPTIONS} onChange={handleOnSelectChange} value={itemsCountPerPage} />
          </RangeSelectorContainer>
        )}
      </RangeSelectorWrapper>
      <NavigationWrapper>
        {/* <Button
            onClick={() => {
              handlePageChange(1)
            }}
            disabled={page === 1}
            variant="transparent"
            size="small"
          >
            Start
          </Button> */}
        <Button
          style={{ marginRight: '20px', padding: '2px 5px' }}
          onClick={() => {
            handlePageChange(page - 1)
          }}
          disabled={page === 1 || !pages || pages?.length < 1 || totalItemsCount < 1}
          variant="outlined"
          size="small"
        >
          <ArrowLeftIcon size={25} />
        </Button>

        <NavigationPagesWrapper>
          {(!pages || pages?.length < 1 || totalItemsCount < 1) && (
            <Button variant="transparent" size="small" disabled>
              ...
            </Button>
          )}
          {pages &&
            totalItemsCount > 0 &&
            pages?.length > 0 &&
            pages?.map((i) => (
              <Button
                style={{ maxWidth: '30px' }}
                key={i}
                onClick={() => {
                  handlePageChange(i)
                }}
                variant={page === i ? '' : 'transparent'}
                size="small"
              >
                {i}
              </Button>
            ))}
        </NavigationPagesWrapper>

        <Button
          style={{ marginLeft: '20px', padding: '2px 5px' }}
          onClick={() => {
            handlePageChange(page + 1)
          }}
          disabled={page >= totalPages || !pages || pages?.length < 1 || totalItemsCount < 1}
          variant="outlined"
          size="small"
        >
          <ArrowRightIcon size={25} />
        </Button>
        {/* <Button
            onClick={() => {
              handlePageChange(totalPages)
            }}
            disabled={page === totalPages}
            variant="transparent"
            size="small"
          >
            End
          </Button> */}
      </NavigationWrapper>
      <RangeSelectorWrapper>
        {totalItemsCount > 0 && pages?.length > 0 && (
          <SummaryContainer>{`Displayed: ${itemsCountPerPage * page} / ${totalItemsCount}`}</SummaryContainer>
        )}
      </RangeSelectorWrapper>
    </PaginationWrapper>
  )
}

// Default Props
Pagination.defaultProps = {
  onChange: () => {},
  itemsCountPerPage: 10,
  totalItemsCount: 10,
  pageRangeDisplayed: 5,
  page: 0,
}

// Proptypes Validation
Pagination.propTypes = {
  onChange: PropTypes.func,
  itemsCountPerPage: PropTypes.number,
  totalItemsCount: PropTypes.number,
  pageRangeDisplayed: PropTypes.number,
  page: PropTypes.number,
}

export default Pagination
